var __WEBPACK_NAMESPACE_OBJECT__ = require("agora-rtc-sdk-ng");